import React from 'react'

import MobileModal, { MobileModalProps } from '../MobileModal'
import ClientChatInbox from '../../../../pages/ClientChats/ClientChaInbox'

import { useAppSelector } from '../../../../hooks/redux'
import { selectBaseInbox } from '../../../../slices/baseInbox'
import useStyles from './styles'

interface MobileSelectInboxModalProps
  extends Omit<MobileModalProps, 'title' | 'children'> {}

const MobileSelectInboxModal: React.FC<MobileSelectInboxModalProps> = props => {
  const { inboxes } = useAppSelector(selectBaseInbox)

  const classes = useStyles()

  return (
    <MobileModal title='Inboxes' {...props}>
      <div className={classes.root}>
        {inboxes.map(inbox => (
          <ClientChatInbox
            key={inbox.id}
            inbox={inbox}
            onClick={props.onClose}
            className={classes.inbox}
            expandView
          />
        ))}
      </div>
    </MobileModal>
  )
}

export default MobileSelectInboxModal
